import api from '../../api/axios';
import { AUTH_VALIDATE_SUCCESS } from './validateAction';
import { showSuccess, showError } from '../../Components/reuse/Toast';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
export const clearAuthError = () => ({ type: CLEAR_AUTH_ERROR });

export const logout = (options) => (dispatch) => {
  const { showMessage = true, message = 'Session expired. Please login again.' } = options || {};
  // Clear auth storage
  try { localStorage.removeItem('token'); } catch (_) {}
  try { localStorage.clear(); } catch (_) {}
  try { sessionStorage.clear(); } catch (_) {}
  
  // Dispatch logout action to clear Redux state
  dispatch({ type: 'AUTH_LOGOUT' });
  
  // Clear axios default headers
  try { delete api.defaults.headers.common.Authorization; } catch (_) {}
  if (window.axios && window.axios.defaults && window.axios.defaults.headers && window.axios.defaults.headers.common) {
    try { delete window.axios.defaults.headers.common.Authorization; } catch (_) {}
  }
  
  // Show notification to user
  if (showMessage) {
    showError(message);
  }
  
  // Hard redirect to login (full page reload)
  try {
    window.location.replace('/login');
  } catch (_) {
    window.location.href = '/login';
  }
};

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_REQUEST });
    const response = await api.post(`auth/signin`, { email, password });
    const envelope = response.data; // expected: { success, message, data: <user>, token }
    const token = envelope?.token || envelope?.data?.token || null;
    const userpackageinfos = envelope?.data?.userpackageinfos || null;
    const possibleUser = envelope?.data || envelope?.user || envelope?.data?.user || null;
    const user = possibleUser && possibleUser._id ? possibleUser : null;
    if (token) {
      try { localStorage.removeItem('token'); } catch (_) {}
      localStorage.setItem('token', token);
      try { api.defaults.headers.common.Authorization = `Bearer ${token}`; } catch (_) {}
    }
    dispatch({ type: LOGIN_SUCCESS, payload: { token } });
    if (user) {
      dispatch({ type: AUTH_VALIDATE_SUCCESS, payload: { user, userpackageinfos, token: token || localStorage.getItem('token') || null } });
    }
    showSuccess('Logged in successfully');
    return envelope;
  } catch (error) {
    const message = error?.response?.data?.message || 'Invalid email or password';
    dispatch({ type: LOGIN_FAILURE, error: message });
    showError(message);
    throw new Error(message);
  }
};

export const signup = (company, email, password, storeUrl, partner_id) => async (dispatch) => {
  try {
    dispatch({ type: SIGNUP_REQUEST });
    const response = await api.post(`auth/signup`, { company, email, password, storeUrl, partner_id });
    const data = response.data;
    dispatch({ type: SIGNUP_SUCCESS, payload: data });
    showSuccess('Account created successfully');
    return data;
  } catch (error) {
    const apiErrors = error?.response?.data?.errors;
    const backendMsg = error?.response?.data?.message;
    const message = (Array.isArray(apiErrors) && apiErrors.length > 0)
      ? apiErrors.map(e => e?.msg).filter(Boolean).join(', ')
      : (backendMsg || 'Signup failed');
    dispatch({ type: SIGNUP_FAILURE, error: message });
    showError(message);
    throw new Error(message);
  }
};

export const forgotPassword = (email) => async (dispatch) => {
  try {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });
    const response = await api.post(`auth/forgotPassword`, { email });
    const data = response.data;
    dispatch({ type: FORGOT_PASSWORD_SUCCESS, payload: data });
    showSuccess(data.message || 'Password reset email sent successfully');
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to send password reset email';
    dispatch({ type: FORGOT_PASSWORD_FAILURE, error: message });
    showError(message);
    throw new Error(message);
  }
};

export const resetPassword = (token, newPassword) => async (dispatch) => {
  try {
    dispatch({ type: RESET_PASSWORD_REQUEST });
    const response = await api.post(`auth/resetPassword`, { token, newPassword });
    const data = response.data;
    dispatch({ type: RESET_PASSWORD_SUCCESS, payload: data });
    showSuccess(data.message || 'Password reset successfully');
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to reset password';
    dispatch({ type: RESET_PASSWORD_FAILURE, error: message });
    showError(message);
    throw new Error(message);
  }
};

export const changePassword = (oldPassword, newPassword) => async (dispatch) => {
  try {
    dispatch({ type: CHANGE_PASSWORD_REQUEST });
    const response = await api.post(`auth/changePassword`, { oldPassword, newPassword });
    const data = response.data; // expected: { success, message }
    dispatch({ type: CHANGE_PASSWORD_SUCCESS, payload: data });
    showSuccess(data?.message || 'Password changed successfully');
    // Give the success toast a moment to display before logging out
    setTimeout(() => {
      try {
        dispatch(logout({ showMessage: false }));
      } catch (_) {}
    }, 800);
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to change password';
    dispatch({ type: CHANGE_PASSWORD_FAILURE, error: message });
    showError(message);
    throw new Error(message);
  }
};
